import { createSlice } from '@reduxjs/toolkit'

export const BookingHubSlice = createSlice({
  name: 'bookingHub',
  initialState: {
    hubDetailsByGid: {},
    locationsByGid: {},
  },
  reducers: {
    setHubDetailsCache: (state, action) => {
      const { gid, details } = action.payload;
      state.hubDetailsByGid[gid] = details;
    },
    setLocationsCache: (state, action) => {
      const { gid, locations } = action.payload;
      state.locationsByGid[gid] = locations;
    },
  },
})

export const { setHubDetailsCache, setLocationsCache } = BookingHubSlice.actions
export default BookingHubSlice.reducer
